import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'bz-call-parent',
  templateUrl: './call-parent.component.html',
  styleUrls: ['./call-parent.component.scss']
})
export class CallParentComponent implements OnInit {

  constructor(private route: ActivatedRoute,) { }


  ngOnInit(): void {

    this.route.queryParams.subscribe(queryParams => {

      window.parent?.postMessage(
          {
          type:'CGResponse',
          variable: queryParams
          }, '*');
        });
  }
}
